<script>
import "vis-timeline/dist/vis-timeline-graph2d.min.css"
import { Timeline, DataSet } from "vis-timeline/standalone"
import InstrumentListItem from "@/components/instrument/InstrumentListItem"
export default {
  name: "InstrumentList",
  components: {
    InstrumentListItem,
  },
  props: {
    instrumentList: Array,
    masterStartDate: String,
    masterEndDate: String,
    submittedStartDate: String,
    submittedEndDate: String,
    site: {
      type: [Object, String, Array],
      default: null,
    },
    facility: {
      type: [Object, String, Array],
      default: null,
    },
    instrument: {
      type: [Object, String, Array],
      default: null,
    },
  },
  data() {
    return { 
      timelineId: "timeline",
      dataset: [],
      timeline: null,
      currentPage: 1,
      itemsPerPage: 8,
     
    }
  },
  computed: {
    totalItems() {
      return this.instrumentList.length
    },
    totalPages() {
      return Math.ceil(this.totalItems / this.itemsPerPage)
    },
    filteredInstruments() {
      // Start with all instruments
      let filtered = this.instrumentList || []
      // Check valid filter values
      const hasSite = this.site && (typeof this.site === "string" ? this.site : this.site.code)
      const hasFacility = this.facility && (typeof this.facility === "string" ? this.facility : this.facility.code)
      const hasInstrument = this.instrument && (typeof this.instrument === "string" ? this.instrument : this.instrument.code)
      // Get actual values to compare against
      const siteValue = typeof this.site === "string" ? this.site : (this.site ? this.site.code : null)
      const facilityValue = typeof this.facility === "string" ? this.facility : (this.facility ? this.facility.code : null)
      const instrumentValue = typeof this.instrument === "string" ? this.instrument : (this.instrument ? this.instrument.code : null)
      //Only instrument is selected
      if (hasInstrument && (!hasSite || !hasFacility)) {
        return filtered.filter(item => item.instrumentClassCode === instrumentValue)
      }
      //Site and facility are both selected
      if (hasSite && hasFacility) {
        filtered = filtered.filter(item => item.siteCode === siteValue && 
          item.facilityCode === facilityValue)
    
        //Site, facility and instrument are all selected
        if (hasInstrument) {
          filtered = filtered.filter(item => item.instrumentClassCode === instrumentValue)
        }
    
        return filtered
      }
      //No valid filters or only site selected - don't filter
      return filtered
    },
    visibleInstruments() {
      const filtered = this.filteredInstruments || []
      const visible = filtered.filter((item) => {
        return item.visible !== false
      })
      return visible
    },
    startIndex() {
      return (this.currentPage - 1) * this.itemsPerPage + 1
    },
    endIndex() {
      const end = this.currentPage * this.itemsPerPage
      return end > this.totalItems ? this.totalItems : end
    },
  },
  watch: {
    masterStartDate(value) {
      if (value) {
        this.displayStartDate = this.formatDateForDisplay(value)
      }
    },
    masterEndDate(value) {
      if (value) {
        this.displayEndDate = this.formatDateForDisplay(value)
      }
    },
    site: {
      handler(newVal) {
        // console.log("Site changed:", newVal)
      },
      deep: true,
    },
    facility: {
      handler(newVal) {
        // console.log("Facility changed:", newVal)
      },
      deep: true,
    },
    instrument: {
      handler(newVal) {
        // console.log("Instrument changed:", newVal)
      },
      deep: true,
    },
    filteredInstruments: {
      handler(newVal) {
        // console.log("Filtered instruments:", newVal.length)
      },
      deep: true,
    },
    
  },
  mounted() {
    if (this.instrumentList && this.instrumentList.length > 0) {
      // console.log("Sample item structure:", this.instrumentList[0])
    }
  }
  ,
  methods: {
    handleSubmitDates() {
      this.submittedStartDate = this.formatDateForSubmission(this.masterStartDate)
      this.submittedEndDate = this.formatDateForSubmission(this.masterEndDate)
    },
    formatDateForDisplay(dateString) {
      if (!dateString) return ""
      const [year, month, day] = dateString.split("-")
      return `${month.padStart(2, "0")}/${day.padStart(2, "0")}/${year}`
    },
    formatDateForSubmission(dateString) {
      if (!dateString) return null
      const [year, month, day] = dateString.split("-")
      return `${month.padStart(2, "0")}-${day.padStart(2, "0")}-${year}`
    },
    updateTimeline() {
      this.$nextTick(() => {
        this.timeline = new Timeline(document.getElementById(this.timelineId), new DataSet(this.dataset))
      })  
    },
    goToPage(page) {
      this.currentPage = page
    },
  },
}
</script>
<template>
  <div class="px-3">  
    <!-- <b-container class="my-3 gx-0" fluid>
      <InstrumentListItem v-for="item in visibleInstruments" :key="item.instrumentClassCode+item.siteCode+item.facilityCode" :value="item" />
     
    </b-container>  -->
    <b-container class="my-3 gx-0" fluid>
      <div v-if="visibleInstruments.length === 0" class="no-data-message">
        No instruments match the selected filters
      </div>

      <InstrumentListItem 
        v-for="item in visibleInstruments" 
        :key="item.instrumentClassCode + item.siteCode + item.facilityCode" 
        :value="item" 
        :site="site"
        :facility="facility"
        :instrument="instrument"
      />
    </b-container>
    <!--@clear-dates="handleClearDates" -->
    <!-- <b-pagination
      v-model="currentPage"
      :total-rows="totalItems"
      :per-page="itemsPerPage"
      aria-controls="instrument-list"
    />
    <div class="resultCount">
      Displaying {{ startIndex }} - {{ endIndex }} of {{ totalItems }} rows
    </div><br /> -->
  </div>
</template>
<style scoped>
.date-picker-container {
  display: flex;
  justify-content: center; 
  gap: 10px; 
  margin-top: 20px;                 
  margin-bottom: 10px; 
}
.date-picker,
.submit-button {
  height: 40px;             
  padding: 5px 10px;     
  font-size: 16px;     
  border: 1px solid #ddd; 
  border-radius: 4px;   
}
.date-picker {
  width: auto;             
  flex: 1; 
}
.submit-button {
  white-space: nowrap; 
}
.results-text {
  text-align: center;  
}
</style>
